import { render, staticRenderFns } from "./RecentFeedbackWidget.vue?vue&type=template&id=2038a57a&scoped=true"
import script from "./RecentFeedbackWidget.vue?vue&type=script&lang=js"
export * from "./RecentFeedbackWidget.vue?vue&type=script&lang=js"
import style0 from "./RecentFeedbackWidget.vue?vue&type=style&index=0&id=2038a57a&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2038a57a",
  null
  
)

export default component.exports